export default __webpack_public_path__ + "static/media/gorillaz-laugh.91d9ffb0.mp3";